export enum AppNotificationCategory {
  general = 'general',
  security = 'security',
  logistics = 'logistics',
  management = 'management',
  video_system = 'video_system',
  road_vision = 'road_vision',
  driver_vision = 'driver_vision',
  identification_vision = 'identification_vision',
}
